import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class IssueDateService {

	constructor(private http: HttpClient) { }

	public getDatesForPackageAndPlacement(packageId: string, placementId: string): Observable<Date[]> {
		const url = BackendAPI.staticDataDatesForPackageAndPlacement;
		const now = new Date();
		const requestParams = new HttpParams()
			.set("packageId", packageId)
			.set("placementId", placementId)
			.set("startYear", now.getFullYear().toString())
			.set("startMonth", (now.getMonth() + 1).toString())
			.set("monthCount", (12).toString())

		return this.http.get<string[]>(url, { params: requestParams })
			.pipe(
				map(issues => issues.map(issue => new Date(issue))) // The Date's constructor correctly processes the strings like YYYY-MM-DD
			);
	}
}
